export const en = {
    'add-creatives': {
        one: 'Add a creative format: {formats} to expand audience coverage',
        some: 'Add creative formats: {formats} to expand audience coverage',
        many: 'Add creative formats: {formats} to expand audience coverage',
        none: ''
    },
    title: 'Upload creatives in suitable formats',
    'title-hint': 'This recommendation appears as there are no creatives suitable for the billboards selected',
    'video-format': '{width}x{height}, {duration}sec.'
};
